import React from 'react'

import { ArcadeModalPortal, ArcadeModalPortalProps, ArcadeModalProps } from '@cash-design-system/react'

import { useModalSharedProps } from '../utils/useModalSharedProps'

export type ModalPortalProps = Omit<ArcadeModalPortalProps, 'ariaLabel' | 'closeButtonProps' | 'backButtonProps'> & {
  closeButtonProps?: Partial<ArcadeModalProps['closeButtonProps']>
  backButtonProps?: Partial<ArcadeModalProps['backButtonProps']>
}

export const ModalPortal = React.forwardRef<HTMLDivElement, ModalPortalProps>((props, ref) => {
  const sharedProps = useModalSharedProps(props)

  return <ArcadeModalPortal {...sharedProps} ref={ref} />
})

ModalPortal.displayName = 'Shared ModalPortal'

export default ModalPortal
